export default __webpack_public_path__ + "static/indie-pc-061b1e563ad725a02a69ce7967aaf539.png";